import React, { useState } from 'react';
import { Button, ButtonToolbar, Table, Loader } from "rsuite";
import Modal from "rsuite/Modal";
import useRequestHandler from "hooks/useRequestHandler";
const { Column, HeaderCell, Cell } = Table;

const DeleteBed = (props) => {
    const { auth, formValues, modalOpen, setModalOpen, refreshData } = props;
    const { bedId } = formValues;
    const [loaderContent, setLoaderContent] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const deleteBedRequest = useRequestHandler({
        auth,
        apiArguments: [bedId],
        apiName: 'deleteBed',
        successMessageData: {
            message: `Bed ${bedId.id} was successfully deleted.`,
        },
        errorMessageData: {
            title: 'Error',
            message: 'You cannot delete bed that associated with devices or patients.',
            type: 'error'
        }
    });

    const sendRequest = async () => {
        setLoaderContent('Deleting bed');
        setIsLoading(true);

        await deleteBedRequest(
            async () => {
                await refreshData();
                setModalOpen(false);
            }
        )

        setIsLoading(false);
    }

    const closeModal = () => setModalOpen(false);

    return (
        <Modal open={modalOpen} onClose={closeModal} className="bed-modal delete-bed-modal">
            <Modal.Header>
                <Modal.Title><strong>Are you sure to delete the bed below?</strong></Modal.Title>
            </Modal.Header>

            {isLoading &&
                <div className='loader-wrapper'>
                    <Loader size='lg' center content={loaderContent} />
                </div>}

            <Modal.Body className={isLoading ? 'hidden' : ''}>
                <Table data={[{ ...formValues }]} autoHeight className='table'>

                    <Column flexGrow={3}>
                        <HeaderCell><span className='header-cell'>Section</span></HeaderCell>
                        <Cell dataKey='sectionName' />
                    </Column>

                    <Column flexGrow={3}>
                        <HeaderCell><span className='header-cell'>Room Name</span></HeaderCell>
                        <Cell dataKey='roomName' />
                    </Column>

                    <Column flexGrow={3}>
                        <HeaderCell><span className='header-cell'>Bed Name</span></HeaderCell>
                        <Cell dataKey='bedName' />
                    </Column>
                    
                </Table>
                <ButtonToolbar className='btn-toolbar'>
                    <Button
                        type='reset'
                        appearance="ghost"
                        size='lg'
                        className='delete-bed-btn btn-cancel'
                        onClick={closeModal}
                    >Cancel</Button>
                    <Button
                        type='submit'
                        appearance="primary"
                        size='lg'
                        color='red'
                        className='delete-bed-btn'
                        onClick={sendRequest}
                    >Yes</Button>
                </ButtonToolbar>
            </Modal.Body>
        </Modal>
    )
}

DeleteBed.defaultProps = {
    formValues: {
        sectionName: '',
        roomName: '',
        bedName: '',
        bedId: '',
    }
}

export default DeleteBed;


